import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { EvolucionInventarioProps } from "../../containers/pages/Dashboard";
import { RootState } from "../../store";
import { connect } from "react-redux";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);



interface Props {
    data: EvolucionInventarioProps[];
    title?: string;
    anio?: number;
    onEvolucionClick?: (tipo: "ALTAS" | "BAJAS" | "TOTAL_ACTIVOS", mes: string) => void;
    isDarkMode: boolean;
}

const EvolucionInventarioChart: React.FC<Props> = ({ data, title = "Evolución del Inventario", onEvolucionClick, isDarkMode }) => {

    const chartData = {
        labels: data.map((item) => item.mes),

        datasets: [
            {
                label: "Altas",
                data: data.map((item) => item.altas),
                borderColor: "#004485",
                backgroundColor: "#0c83f1",
                borderWidth: 2,
                pointRadius: 2,
                pointHoverRadius: 6,
                tension: 0.3,
                yAxisID: "y",

                datalabels: {
                    display: true,
                    anchor: "center" as const,
                    align: "top" as const,
                    offset: 8,

                    color: "#0c83f1",

                    font: {
                        weight: "bold" as const,
                        size: 11,
                    },

                    formatter: (value: number) =>
                        value.toLocaleString("es-CL"),
                },
            },

            {
                label: "Bajas",
                data: data.map((item) => item.bajas),
                borderColor: "#c24a4a",
                backgroundColor: "#d47b7b",
                borderWidth: 2,
                pointRadius: 2,
                pointHoverRadius: 6,
                tension: 0.3,
                yAxisID: "y",

                datalabels: {
                    display: true,
                    align: "top" as const,
                    anchor: "end" as const,
                    offset: 0,

                    color: "#c24a4a",

                    font: {
                        weight: "bold" as const,
                        size: 12,
                    },

                    formatter: (value: number) =>
                        value.toLocaleString("es-CL"),
                },
            },

            {
                label: "Total de Activos",
                data: data.map((item) => item.totaL_ACTIVOS),
                borderColor: "#2d662d",
                backgroundColor: "#358035",
                borderWidth: 2,
                pointRadius: 2,
                pointHoverRadius: 6,
                tension: 0.3,
                yAxisID: "y",

                datalabels: {
                    display: true,
                    anchor: "center" as const,
                    align: "right" as const,
                    offset: 5,

                    color: "#4ac24a",

                    font: {
                        weight: "bold" as const,
                        size: 12,
                    },

                    formatter: (value: number) =>
                        value.toLocaleString("es-CL"),
                },
            },

        ],
    };

    // NUEVO: acción al seleccionar un punto del gráfico
    const handleEvolucionClick = (_event: any, elements: any[]) => {

        if (!elements || elements.length === 0) {
            return;
        }

        // NUEVO: obtenemos el mes según la posición X
        const index = elements[0].index;

        // NUEVO: obtenemos qué línea fue seleccionada
        const datasetIndex = elements[0].datasetIndex;

        // NUEVO: convertimos ENE = 1, FEB = 2, ..., DIC = 12
        const mes = String(index + 1).padStart(2, "0");

        // NUEVO: identificamos el tipo según la línea seleccionada
        let tipo: | "ALTAS" | "BAJAS" | "TOTAL_ACTIVOS";

        switch (datasetIndex) {
            case 0:
                tipo = "ALTAS";
                break;

            case 1:
                tipo = "BAJAS";
                break;

            case 2:
                tipo = "TOTAL_ACTIVOS";
                break;

            default:
                return;
        }



        if (onEvolucionClick) {
            onEvolucionClick(
                tipo,
                mes,
            );

        }
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,

        interaction: {
            // permite identificar específicamente el punto seleccionado
            mode: "nearest" as const,
            intersect: true,
        },

        plugins: {
            legend: {
                position: "top" as const,

                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    padding: 15,
                    color: isDarkMode ? "#ffffff" : ""
                },
            },

            title: {
                display: false,
                text: title,

            },

            tooltip: {
                callbacks: {
                    label: function (context: any) {

                        const label =
                            context.dataset.label || "";

                        const value =
                            context.parsed.y ?? 0;

                        return `${label}: ${value.toLocaleString(
                            "es-CL"
                        )}`;
                    },
                },
            },
        },

        // evento que detecta el punto seleccionado
        onClick: handleEvolucionClick,

        scales: {
            x: {
                grid: {
                    display: true,
                    color: isDarkMode ? "#ffffff2a" : "#c5bfbf46",
                },
                ticks: {
                    color: isDarkMode ? "#ffffffa9" : "#30353ac4",
                    font: {
                        size: 11,
                    },
                }
            },
            y: {

                grid: {
                    display: true,
                    color: isDarkMode ? "#ffffff2c" : "#c5bfbf46",
                },
                ticks: {
                    color: isDarkMode ? "#ffffffa9" : "#30353ac4",
                    font: {
                        size: 11,
                    },
                }
            },

        },

    };

    return (
        <div

            style={{
                width: "100%",
                height: "320px",
            }}
        >
            <Line
                data={chartData}
                options={chartOptions}

            />
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    isDarkMode: state.darkModeReducer.isDarkMode,
});
export default connect(mapStateToProps, {
}
)(EvolucionInventarioChart);